import assign from 'object-assign';
import { EventEmitter } from 'events';
import { isEqual, } from 'lodash';
import AdminAppDispatcher from '../dispatcher/AdminAppDispatcher';
import AdminConstants from '../constants/AdminConstants';
import { mapStagingShipment } from '../helpers/order-shipments';
const ActionTypes = AdminConstants.ActionTypes;
const CHANGE_EVENT = 'ORDERS_CHANGED';
const SEARCH_EVENT = 'SEARCH_RESULTS_RETURNED';
const STOP_EQUIPMENT_CREATED = 'STOP_EQUIPMENT_CREATED';
const STAGING_SHIPMENTS_CHANGED = 'STAGING_SHIPMENTS_CHANGED';
let audits = [];
let ordersPayload = {
    orders: [],
    pages: 1,
    total: 0,
};
let order = null;
let ordersSearchResults = null;
const errorMessages = {
    getOrdersError: null,
    getOrderError: null,
    updateOrderError: null,
    cancelOrderError: null,
    uploadOrderDocumentError: null,
    deleteOrderDocumentError: null,
    addOrderEquipmentError: null,
    removeOrderEquipmentError: null,
};
let stagingStopEquipmentContext = {
    stagingShipmentId: null,
    stopSequence: null,
    equipment: null,
};
let stagingShipments;
const OrdersStore = assign({}, EventEmitter.prototype, {
    emitChange() {
        this.emit(CHANGE_EVENT);
    },
    emitSearchResult() {
        this.emit(SEARCH_EVENT);
    },
    emitStopEquipmentCreatedEvent(context) {
        this.emit(STOP_EQUIPMENT_CREATED, context);
    },
    emitStagingShipmentsChange() {
        this.emit(STAGING_SHIPMENTS_CHANGED);
    },
    addChangeListener(callback) {
        this.on(CHANGE_EVENT, callback);
    },
    addSearchResultsChangeListener(callback) {
        this.on(SEARCH_EVENT, callback);
    },
    addStopEquipmentCreatedListener(callback) {
        this.on(STOP_EQUIPMENT_CREATED, callback);
    },
    addStagingShipmentsChangeListener(callback) {
        this.on(STAGING_SHIPMENTS_CHANGED, callback);
    },
    removeChangeListener(callback) {
        this.removeListener(CHANGE_EVENT, callback);
    },
    removeSearchResultsChangeListener(callback) {
        this.removeListener(SEARCH_EVENT, callback);
    },
    removeStopEquipmentCreatedListener(callback) {
        this.removeListener(STOP_EQUIPMENT_CREATED, callback);
    },
    removeStagingShipmentsChangeListener(callback) {
        this.removeListener(STAGING_SHIPMENTS_CHANGED, callback);
    },
    getOrdersPayload() {
        return ordersPayload;
    },
    updateOrders(payload) {
        const { orders, pages, total_entries: total, } = payload;
        ordersPayload = {
            orders,
            pages,
            total,
        };
        this.emitChange();
    },
    getAudits() {
        return audits;
    },
    getOrder() {
        return order;
    },
    getStagingStopEquipmentContext() {
        return stagingStopEquipmentContext;
    },
    getStagingShipments() {
        return stagingShipments;
    },
    updateOrder(payload) {
        order = payload;
        this.emitChange();
        this.updateStagingShipments(order.shipments_staging);
    },
    updateStagingShipments(items) {
        const nextStagingShipments = (items || []).map(mapStagingShipment);
        if (!isEqual(stagingShipments, nextStagingShipments)) {
            stagingShipments = nextStagingShipments;
            this.emitStagingShipmentsChange();
        }
    },
    onCustomDeliveryOrderGenerated(updatedOrder) {
        order = updatedOrder;
        this.emitChange();
    },
    onGetOrdersFail(message) {
        errorMessages.getOrdersError = message;
        this.emitChange();
    },
    onGetOrderFail(message) {
        errorMessages.getOrderError = message;
        this.emitChange();
    },
    onCancelOrderFail(message) {
        errorMessages.cancelOrderError = message;
        this.emitChange();
    },
    onUpdateOrderFail(message) {
        errorMessages.updateOrderError = message;
        this.emitChange();
    },
    onUploadOrderDocumentFail(message) {
        errorMessages.uploadOrderDocumentError = message;
        this.emitChange();
    },
    onDeleteOrderDocumentFail(message) {
        errorMessages.deleteOrderDocumentError = message;
        this.emitChange();
    },
    onAddEquipmentFail(message) {
        errorMessages.addOrderEquipmentError = message;
        this.emitChange();
    },
    onRemoveEquipmentFail(message) {
        errorMessages.removeOrderEquipmentError = message;
        this.emitChange();
    },
    clearError(errorType) {
        errorMessages[errorType] = null;
        this.emitChange();
    },
    getError(errorType) {
        return errorMessages[errorType];
    },
    clearAllErrors() {
        Object.keys(errorMessages).forEach((e) => {
            errorMessages[e] = null;
        });
        this.emitChange();
    },
    onGetOrderAudit(payload) {
        audits = payload;
        this.emitChange();
    },
    updateOrdersSearchResults(result) {
        if (result && result.entity) {
            ordersSearchResults = result.entity.items;
        }
        else {
            ordersSearchResults = [];
        }
        this.emitSearchResult();
    },
    getOrdersSearchResults() {
        return ordersSearchResults;
    },
    setStagingStopEquipmentContext({ stagingShipmentId, sequence }) {
        stagingStopEquipmentContext = {
            stagingShipmentId,
            sequence,
        };
    },
    onEquipmentCreatedForStagingStop(equipment) {
        if (!order) {
            return;
        }
        stagingStopEquipmentContext.equipment = equipment;
        this.emitStopEquipmentCreatedEvent(stagingStopEquipmentContext);
    },
    onResetStagingShipments() {
        stagingShipments = undefined;
    },
});
OrdersStore.dispatchToken = AdminAppDispatcher.register(function (payload) {
    const action = payload.action;
    switch (action.type) {
        case ActionTypes.FETCH_ORDERS_SUCCESS:
            errorMessages.getOrdersError = null;
            OrdersStore.updateOrders(action.payload);
            break;
        case ActionTypes.FETCH_ORDERS_FAIL:
            OrdersStore.onGetOrdersFail(action.error);
            break;
        case ActionTypes.TRANSITION_ORDER_SUCCESS:
            errorMessages.getOrderError = null;
            OrdersStore.updateOrder(action.order);
            break;
        case ActionTypes.TRANSITION_ORDER_FAIL:
            OrdersStore.onGetOrderFail(action.error);
            break;
        case ActionTypes.FETCH_ORDER_SUCCESS:
            errorMessages.getOrderError = null;
            OrdersStore.updateOrder(action.order);
            break;
        case ActionTypes.FETCH_ORDER_FAIL:
            OrdersStore.onGetOrderFail(action.error);
            break;
        case ActionTypes.UPDATE_ORDER_SUCCESS:
            errorMessages.updateOrderError = null;
            OrdersStore.updateOrder(action.order);
            break;
        case ActionTypes.UPDATE_ORDER_FAIL:
            OrdersStore.onUpdateOrderFail(action.error);
            break;
        case ActionTypes.UPLOAD_ORDER_DOCUMENT_SUCCESS:
            errorMessages.uploadOrderDocumentError = null;
            OrdersStore.updateOrder(action.order);
            break;
        case ActionTypes.UPLOAD_ORDER_DOCUMENT_FAIL:
            OrdersStore.onUploadOrderDocumentFail(action.error);
            break;
        case ActionTypes.DELETE_ORDER_DOCUMENT_SUCCESS:
            errorMessages.deleteOrderDocumentError = null;
            OrdersStore.updateOrder(action.order);
            break;
        case ActionTypes.DELETE_ORDER_DOCUMENT_FAIL:
            OrdersStore.onDeleteOrderDocumentFail(action.error);
            break;
        case ActionTypes.CANCEL_ORDER_SUCCESS:
            errorMessages.cancelOrderError = null;
            OrdersStore.updateOrder(action.order);
            break;
        case ActionTypes.CANCEL_ORDER_FAIL:
            OrdersStore.onCancelOrderFail(action.error);
            break;
        case ActionTypes.ADD_ORDER_EQUIPMENT_SUCCESS:
            errorMessages.addOrderEquipmentError = null;
            OrdersStore.updateOrder(action.order);
            break;
        case ActionTypes.ADD_ORDER_EQUIPMENT_FAIL:
            OrdersStore.onAddEquipmentFail(action.error);
            break;
        case ActionTypes.REMOVE_ORDER_EQUIPMENT_SUCCESS:
            errorMessages.removeOrderEquipmentError = null;
            OrdersStore.updateOrder(action.order);
            break;
        case ActionTypes.REMOVE_ORDER_EQUIPMENT_FAIL:
            OrdersStore.onRemoveEquipmentFail(action.error);
            break;
        case ActionTypes.FETCH_ORDER_AUDIT_SUCCESS:
            OrdersStore.onGetOrderAudit(action.audits);
            break;
        case ActionTypes.GENERATE_ORDER_INVOICE_SUCCESS:
            errorMessages.getOrderError = null;
            OrdersStore.updateOrder(action.order);
            break;
        case ActionTypes.GENERATE_ORDER_PAYOUT_SUCCESS:
            errorMessages.getOrderError = null;
            OrdersStore.updateOrder(action.order);
            break;
        case ActionTypes.BULK_ADD_ACCESSORIALS_SUCCESS:
            OrdersStore.updateOrder(action.result.order);
            break;
        case ActionTypes.ORDERS_SEARCH_SUCCESS:
            OrdersStore.updateOrdersSearchResults(action.result);
            break;
        case ActionTypes.GENERATE_CUSTOM_DELIVERY_ORDER_SUCCESS:
            OrdersStore.onCustomDeliveryOrderGenerated(action.order);
            break;
        case ActionTypes.SAVE_AND_APPLY_TRIP_SUCCESS:
            OrdersStore.updateOrder(action.order);
            break;
        case ActionTypes.ADD_EQUIPMENT_FOR_STAGING_STOP_REQUEST:
            OrdersStore.setStagingStopEquipmentContext({
                stagingShipmentId: action.stagingShipmentId,
                sequence: action.sequence,
            });
            break;
        case ActionTypes.ADD_EQUIPMENT_FOR_STAGING_STOP_SUCCESS:
            OrdersStore.onEquipmentCreatedForStagingStop(action.equipment);
            break;
        case ActionTypes.RESET_STAGING_SHIPMENTS:
            OrdersStore.onResetStagingShipments();
            break;
        default:
            break;
    }
});
export default OrdersStore;
